import { FiChevronDown } from "react-icons/fi";
import PublisherFilterDropdown from "./PublisherFilterDropdown";

export default function HorizontalBookFilter({ filters, categories, publishers }) {
	return (
		<div className="catalogue-quick-selects">
			<div className="catalogue-category">
				<label className="sr-only" htmlFor="catalogue-category">Category</label>
				<select id="catalogue-category" value={filters.categoryIs} onChange={(event) => filters.changeCategoryIs(event.target.value)}>
					<option value="">All categories</option>
					{(Array.isArray(categories) ? categories : []).map((category) => <option key={category.id || category.name} value={category.name}>{category.name}</option>)}
				</select><FiChevronDown aria-hidden="true" />
			</div>
			<PublisherFilterDropdown publishers={publishers} value={filters.publisherIs} onChange={filters.changePublisherIs} />
		</div>
	);
}
